import { api, MEMBER_API_SUB_URLS, V2 } from '@/api';
import { AxiosResponse } from 'axios';
import { Module } from 'vuex';
import {
  RootState,
  MemberPaymentMethodsResponseModel,
  MemberDependentResponseModel,
} from '@/@types/member';

interface PaymentMethodsState {
  paymentMethods: MemberPaymentMethodsResponseModel;
  dependents: MemberDependentResponseModel[];
}

const PAYMENT_METHODS_STATE: Module<PaymentMethodsState, RootState> = {
  state: {
    paymentMethods: null,
    dependents: [],
  },
  actions: {
    // UC-REST-014 - Get Payment Methods
    getPaymentMethods(context): Promise<AxiosResponse> {
      return api
        .get(
          `${MEMBER_API_SUB_URLS.members}/${
            context.getters.user.memberId
          }/payment-methods`,
        )
        .then((paymentMethods) => {
          context.commit('setPaymentMethods', paymentMethods.data);
          return paymentMethods.data;
        });
    },
    // UC-REST-015 - Update Crossover Election
    updateCrossoverElection(context, options): Promise<AxiosResponse> {
      return api
        .patch(
          `${MEMBER_API_SUB_URLS.members}/${
            context.getters.user.memberId
          }/crossover-elections`, {
            isMedicalCrossover: options.medicalCrossoverElection,
            isPtpCrossover: options.ptPCrossoverElection,
            isDentalCrossover: options.dentalCrossoverElection,
          },
        )
        .then((paymentMethods) => {
          context.commit('setPaymentMethods', paymentMethods.data);
          return paymentMethods.data;
        });
    },
    // UC-REST-016 - Get Dependents
    getDependents(context): Promise<AxiosResponse> {
      return api
        .get(
          `${MEMBER_API_SUB_URLS.members}/${
            context.getters.user.memberId
          }/dependents${V2}`,
        )
        .then((dependents) => {
          context.commit('setDependents', dependents.data);
          return dependents.data;
        });
    },
    // UC-REST-017 - Add Debit Card
    addDebitCard(context, options): Promise<AxiosResponse> {
      return api
        .post(`${MEMBER_API_SUB_URLS.dependents}/debit-cards${V2}`, options)
        .then((data) => {
          return data.data;
        });
    },
    // UC-REST-018 - Add Dependent
    addDependent(context, options): Promise<AxiosResponse> {
      return api
        .post(
          `${MEMBER_API_SUB_URLS.members}/${
            context.getters.user.memberId
          }/dependents${V2}`,
          options,
        )
        .then((dependent) => {
          return dependent.data;
        });
    },
    // UC-REST-020 - Validate Dependent
    validateDependent(context, options): Promise<AxiosResponse> {
      return api
        .get(
          `${MEMBER_API_SUB_URLS.members}/${
            context.getters.user.memberId
          }/dependents/matches${V2}`,
          {
            params: {
              ...options,
            },
          },
        )
        .then((validateDependent) => {
          return validateDependent.data;
        });
    },
  },
  mutations: {
    setPaymentMethods(
      state: PaymentMethodsState,
      data: MemberPaymentMethodsResponseModel,
    ) {
      state.paymentMethods = data;
    },
    setDependents(
      state: PaymentMethodsState,
      data: MemberDependentResponseModel[],
    ) {
      state.dependents = data;
    },
  },
  getters: {
    paymentMethods(state): MemberPaymentMethodsResponseModel {
      return state.paymentMethods;
    },
    dependents(state): MemberDependentResponseModel[] {
      return state.dependents;
    },
  },
};

export default PAYMENT_METHODS_STATE;
